<div class="container-fluid row col-12 no-gutters">
  <div class="col-xl-9 col-md-9 col-sm-12 col-12 no-gutters">
    <form [formGroup]="qualitySuitesForm" class="col-xl-9 col-md-9 col-sm-12 col-12 m-auto no-gutters">
      <h6 class="col-12 mb-3 text-normal"><strong>Application
          Description</strong>
      </h6>
      <div class="col-12 text-normal mb-3">
        Quality Suite is an tool designed to manage Renewables Quality processes with suppliers.
      </div>
      <h6 class="col-12 text-normal"><strong>Registration
          Question</strong>
      </h6>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          <span>
            Request Type
            <span style="color: red;">*</span>
          </span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <mat-select formControlName="type" placeholder="Select Request Type?">
            <mat-option *ngFor="let item of types" [value]="item">
              {{item}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Supplier Company Name
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="companyName" name="companyName" matInput #companyName placeholder="" maxlength="50">
          <mat-hint align="end">{{companyName.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Supplier Contact Full Name
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="name" name="name" matInput #name placeholder="" maxlength="50">
          <mat-hint align="end">{{name.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Supplier Contact SSO ID
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="SSOID" name="SSOID" matInput #SSOID placeholder="" maxlength="50">
          <mat-hint align="end">{{SSOID.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Supplier Contact Email
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="email" name="email" matInput #email placeholder="" maxlength="50">
          <mat-hint align="end">{{email.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Business
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <mat-select formControlName="business" placeholder="Select Business"
            (selectionChange)="selectBusiness($event)">
            <mat-option *ngFor="let item of businesses" [value]="item">
              {{item?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters" *ngIf="qualitySuitesForm.controls.business.value">
        <div class="col-12 text-normal">Quality Suite Module {{qualitySuitesForm.controls.business.value?.id}}
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <mat-select formControlName="qualitySuiteModule" placeholder="Select Quality Suite Module" (selectionChange)="selectModule($event)">
            <mat-option *ngFor="let item of qualitySuitesForm.controls.business.value.qualitySuites" [value]="item">
              {{item}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 p-0 no-gutters" *ngIf="qualitySuitesForm.controls.business.value
      && qualitySuitesForm.controls.qualitySuiteModule.value">
          <div class="row col-12 mt-3 no-gutters" *ngIf="!isHydroModule2() && !isEnableBaseOnModules()">
          <div class="col-12 text-normal">Please provide the Purchase Order number that you require access to
            <span style="color: red;">*</span>
          </div>
          <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
            <input formControlName="access" name="access" matInput #access placeholder="" maxlength="50">
            <mat-hint align="end">{{access.value.length}} / 50</mat-hint>
          </mat-form-field>
        </div>
        <div class="row col-12 mt-3 no-gutters" *ngIf="isHydroModule2()">
          <div class="col-12 text-normal">Supplier Connect (SCX) ID
            <span style="color: red;">*</span>
          </div>
          <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
            <input formControlName="scxID" name="scxID" matInput #scxID placeholder="" maxlength="50">
            <mat-hint align="end">{{scxID.value.length}} / 50</mat-hint>
          </mat-form-field>
        </div>
        <div class="row col-12 mt-3 no-gutters">
          <div class="col-12 text-normal">GSL Number
            <span style="color: red;">*</span>
          </div>
          <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
            <input formControlName="GSLNumber" name="GSLNumber" matInput #GSLNumber placeholder="" maxlength="50">
            <mat-hint align="end">{{GSLNumber.value.length}} / 50</mat-hint>
          </mat-form-field>
        </div>
        <div class="row col-12 mt-3 no-gutters">
          <div class="col-12 text-normal">{{getSiteCodeBasedOnBusiness()}}
            <span style="color: red;">*</span>
          </div>
          <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
            <input formControlName="siteCode" name="siteCode" matInput #siteCode placeholder="" maxlength="50">
            <mat-hint align="end">{{siteCode.value.length}} / 50</mat-hint>
          </mat-form-field>
        </div>
        <div class="row col-12 mt-3 no-gutters">
          <div class="col-12 text-normal">SQE Name/SSO
            <span style="color: red;">*</span>
          </div>
          <div class="col-12 justify-content-center text-normal">
            <mat-form-field floatLabel="never" appearance="outline" class="w-100">
              <input formControlName="SQEName" name="SQEName" matInput #SQEName maxlength="50" numbersOnly readonly>
              <mat-icon matSuffix (click)="searchSSO($event)" style="cursor: pointer;">search</mat-icon>
              <mat-hint align="end">{{SQEName.value.length}} / 50</mat-hint>
            </mat-form-field>
          </div>
        </div>
        <div class="row col-12 mt-3 no-gutters">
          <div class="col-12 text-normal">Job Title
          </div>
          <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
            <input formControlName="jobTitle" name="jobTitle" matInput #jobTitle placeholder="" maxlength="50">
            <mat-hint align="end">{{jobTitle.value.length}} / 50</mat-hint>
          </mat-form-field>
        </div>
        <div class="row col-12 mt-3 no-gutters">
          <div class="col-12 text-normal">Phone Number
          </div>
          <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
            <input formControlName="phone" name="phone" matInput #phone placeholder="" maxlength="50">
            <mat-hint align="end">{{phone.value.length}} / 50</mat-hint>
          </mat-form-field>
        </div>
        <div class="row col-12 mt-3 no-gutters">
          <div class="col-12 text-normal">Extension
          </div>
          <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
            <input formControlName="extension" name="extension" matInput #extension placeholder="" maxlength="50">
            <mat-hint align="end">{{extension.value.length}} / 50</mat-hint>
          </mat-form-field>
        </div>

        <div class="row col-12 mt-3 no-gutters" *ngIf="!isEnableBaseOnModules()">
          <div class="col-12 text-normal">Supplier Country Code
            <span style="color: red;">*</span>
          </div>
          <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
            <input formControlName="supplierCountryCode" name="supplierCountryCode" matInput #supplierCountryCode
              placeholder="" maxlength="50">
            <mat-hint align="end">{{supplierCountryCode.value.length}} / 50</mat-hint>
          </mat-form-field>
        </div>
        <div class="row col-12 mt-3 no-gutters" *ngIf="!isEnableBaseOnModules()">
          <div class="col-12 text-normal">Supplier City
            <span style="color: red;">*</span>
          </div>
          <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
            <input formControlName="supplierCity" name="supplierCity" matInput #supplierCity placeholder=""
              maxlength="50">
            <mat-hint align="end">{{supplierCity.value.length}} / 50</mat-hint>
          </mat-form-field>
        </div>
      </div>
      <!-- <div class="col-12 p-0 no-gutters" *ngIf="qualitySuitesForm.controls.business.value
      && qualitySuitesForm.controls.qualitySuiteModule.value && qualitySuitesForm.controls.business.value.id === 3"> -->
        <!-- <div class="row col-12 mt-3 no-gutters">
          <div class="col-12 text-normal">Zip Code
          </div>
          <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
            <input formControlName="zipCode" name="zipCode" matInput #zipCode placeholder="" maxlength="50">
            <mat-hint align="end">{{zipCode.value.length}} / 50</mat-hint>
          </mat-form-field>
        </div>
        <div class="row col-12 mt-3 no-gutters">
          <div class="col-12 text-normal">GSL Number
            <span style="color: red;">*</span>
          </div>
          <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
            <input formControlName="GSLNumber" name="GSLNumber" matInput #GSLNumber placeholder="" maxlength="50">
            <mat-hint align="end">{{GSLNumber.value.length}} / 50</mat-hint>
          </mat-form-field>
        </div>
        <div class="row col-12 mt-3 no-gutters">
          <div class="col-12 text-normal">Vendor Code
          </div>
          <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
            <input formControlName="vendorCode" name="vendorCode" matInput #vendorCode placeholder="" maxlength="50">
            <mat-hint align="end">{{vendorCode.value.length}} / 50</mat-hint>
          </mat-form-field>
        </div>
        <div class="row col-12 mt-3 no-gutters">
          <div class="col-12 text-normal">Supplier Contact Name #2
          </div>
          <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
            <input formControlName="supplierContactName" name="supplierContactName" matInput #supplierContactName
              placeholder="" maxlength="50">
            <mat-hint align="end">{{supplierContactName.value.length}} / 50</mat-hint>
          </mat-form-field>
        </div>
        <div class="row col-12 mt-3 no-gutters">
          <div class="col-12 text-normal">Supplier SSO ID #2
          </div>
          <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
            <input formControlName="supplierSSOID" name="supplierSSOID" matInput #supplierSSOID placeholder=""
              maxlength="50">
            <mat-hint align="end">{{supplierSSOID.value.length}} / 50</mat-hint>
          </mat-form-field>
        </div>
        <div class="row col-12 mt-3 no-gutters">
          <div class="col-12 text-normal">Supplier Email #2
          </div>
          <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
            <input formControlName="supplierEmail" name="supplierEmail" matInput #supplierEmail placeholder=""
              maxlength="50">
            <mat-hint align="end">{{supplierEmail.value.length}} / 50</mat-hint>
          </mat-form-field>
        </div>
      </div> -->


      <div class="row no-gutters col-12 d-flex align-items-center justify-content-center py-4">
        <button class="btn btn-primary btn-vernova button col-xl-5 col-md-6 col-sm-12 col-12 text-normal" style="font-size: 18px;"
          (click)="submitQualitySuitesForm()">
          <span>
            Request Access
          </span>
        </button>
      </div>
    </form>
  </div>
  <div class="col-sm-12 col-md-3 col-xl-3 no-gutters">
    <div class="row no-gutters col-12 align-items-center justify-content-center d-none d-sm-block">
      <button class="btn btn-primary btn-vernova button col-12" style="font-size: 18px;" (click)="goToApplication()">
        <span>
          Go To Application
          <i class='fa fa-sign-out pl-2' style="color: #fff;"></i>
        </span>
      </button>
    </div>
    <hr>
    <div class="col-12">
      <h6>
        <strong class="mt-3 text-lable">
          Support
        </strong>
      </h6>
      <div class="col-12 mt-3 p-0 text-normal d-block d-sm-none">
        <button class="btn btn-primary btn-vernova button col-12" style="font-size: 18px;" (click)="goToApplication()">
          <span>
            Go To Application
            <i class='fa fa-sign-out pl-2' style="color: #fff;"></i>
          </span>
        </button>
        <hr>
      </div>
      <div class="col-12 mt-3 p-0 text-normal">
        GE Renewable Energy Supplier Support (<a href="mailto:GERenEnergy.SupplierSupport@ge.com" style="word-wrap: break-word;" class="text-highlight">~GE Vernova Supplier Support</a>)
      </div>
    </div>
    <hr>
    <div class="d-flex col-12 no-gutters">
      <h6><strong class="mt-3 text-lable">Request Created</strong></h6>
      <div id="refresh" class="header-links ml-auto" style="padding-right: 2px;">
        <i class="fa fa-refresh" style="cursor: pointer; color: #005E60;"
        (click)="getListTicket($event)"></i>
      </div>
    </div>
    <div class="col-12 border-box no-gutters d-flex align-items-center justify-content-center">
      <div class="col-11 no-gutters">
        <div class="col-12 text-normal no-gutters" *ngFor="let item of request; let first = first; let last = last">
          <div class="pt-3 col-12" *ngIf="first">
            <div>
              Request submitted at
            </div>
            <div>
              {{item?.date | date:'medium'}}
            </div>
          </div>
          <div class="col-12" *ngIf="!first">
            <div>
              Request submitted at
            </div>
            <div>
              {{item?.date | date:'medium'}}
            </div>
          </div>
          <div class="py-2">
            <div>
              Request ID number:
            </div>
            <div>{{item?.number}}</div>
            <!-- <a href="{{item?.requestUrl}}" target="_blank">
              {{item?.number}}
            </a> -->
          </div>
          <div class="pb-3" *ngIf="last && item?.status">
            <div>Status: </div>
            <div>{{item?.status}}</div>
          </div>
          <div *ngIf="!last && item?.status">
            <div>Status: </div>
            <div>{{item?.status}}</div>
          </div>
          <hr *ngIf="!last">
        </div>
      </div>
    </div>
  </div>
</div>